import { lazyInitializeExtensibilityContext } from 'owa-addins-core';
import { isFeatureEnabled } from 'owa-feature-flags';

export default async function initializeExtensibilityContext() {
    if (!isFeatureEnabled('rp-addins')) {
        return;
    }

    (await lazyInitializeExtensibilityContext.import())();
}
